<template>
  <v-container fluid>
    <back-link-component :to="{ name: 'FieldListAsList' }" :label="$tt('customFieldsList')" />
    <h2>{{ $tt('customFieldUploadTitle') }}</h2>
    <geo-file-import :importMode="importMode" />
  </v-container>
</template>

<script>
import GeoFileImport from '@/components/import/GeoFileImport'
import * as Constants from '@/lib/constants'

export default {
  name: 'FieldImport',
  components: {
    GeoFileImport,
  },
  data() {
    return {
      importMode: Constants.IMPORT_MODE.FIELDS,
    }
  },
}
</script>
